import React from "react";
import { Link } from "react-router-dom";
// 2024-12-30 SEMIQUZ
import Logo from "./images/SEMIQUZ-bi.png";

/* 폰트어썸 import */
import { faGear } from '@fortawesome/free-solid-svg-icons';
import { faHouse } from '@fortawesome/free-solid-svg-icons';
import { faWrench } from '@fortawesome/free-solid-svg-icons';
// 2024-12-30 SEMIQUZ
import { faPhone, faFax, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getIsLogin, getIsAdmin } from '../utils/session';

function SideNav() {
    // session.js 유틸을 boolean 그대로 사용한다. 문자열 호환 변환은 회귀 위험이라 제거.
    const isLogin = getIsLogin();
    const isAdmin = getIsAdmin();
  
    return (
        <div className="sidenav-container">
            <div className="sidenav-wrap">
            {
                isAdmin ?
                <div className="sidenav-list-wrap" id="listLogin">
                {
                    isLogin ?
                    <Link to='/AdminSetting'>
                        <img style={{marginTop: "32px", marginBottom: "32px", marginLeft: "18px"}} src={Logo} alt="로고" />
                    </Link>
                    :
                    <Link to='/'>
                        <img style={{marginTop: "32px", marginBottom: "32px", marginLeft: "18px"}} src={Logo} alt="로고" />
                    </Link>
                }
                {
                    isLogin ?
                    <>
                    <ul>
                        <li>
                            <Link className="side-nav-item" to="/AdminSetting">
                                <FontAwesomeIcon icon={faHouse} />
                                <span>관리자 설정</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="side-nav-item" to="/Registration">
                                <FontAwesomeIcon icon={faGear} />
                                <span>등록 관리</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="side-nav-item" to="/Management">
                                <FontAwesomeIcon icon={faWrench} />
                                <span>장비 관리</span>
                            </Link>
                        </li>
                    </ul>
                    <ul className="footer" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li style={{ marginTop: '150px', marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>고객센터</p>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faPhone} />
                                <span>070-4352-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faFax} />
                                <span>070-4325-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <a href="mailto:support@semiquz.co.kr" style={{ color: '#ccc', textDecoration: 'none' }}>
                                    support@semiquz.co.kr
                                </a>
                            </div>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Address</p>
                            <p>
                                경기도 평택시 고덕중앙로 200-4 (고덕동, 우성고덕타워)
                                <br />
                                (우 18014)
                            </p>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>English Address</p>
                            <p>
                                200-4, Godeokjungang-ro,
                                <br />
                                Pyeongtaek-si, Gyeonggi-do,
                                <br />
                                Republic of Korea, zip code: 18014
                            </p>
                        </li>
                        <li className="copyright" style={{ marginTop: '20px' }}>
                            Copyright ⓒ 2025 SEMIQUZ, All Right Reserved.
                        </li>
                    </ul>
                    </>
                    :
                    <ul className="footer" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li style={{ marginTop: '150px', marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>고객센터</p>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faPhone} />
                                <span>070-4352-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faFax} />
                                <span>070-4325-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <a href="mailto:support@semiquz.co.kr" style={{ color: '#ccc', textDecoration: 'none' }}>
                                    support@semiquz.co.kr
                                </a>
                            </div>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Address</p>
                            <p>
                                경기도 평택시 고덕중앙로 200-4 (고덕동, 우성고덕타워)
                                <br />
                                (우 18014)
                            </p>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>English Address</p>
                            <p>
                                200-4, Godeokjungang-ro,
                                <br />
                                Pyeongtaek-si, Gyeonggi-do,
                                <br />
                                Republic of Korea, zip code: 18014
                            </p>
                        </li>
                        <li className="copyright" style={{ marginTop: '20px' }}>
                            Copyright ⓒ 2025 SEMIQUZ, All Right Reserved.
                        </li>
                    </ul>
                }
                </div>
                :
                <div className="sidenav-list-wrap" id="listLogin">
                {
                    isLogin ?
                    <Link to='/Home'>
                        <img style={{marginTop: "32px", marginBottom: "32px", marginLeft: "18px"}} src={Logo} alt="로고" />
                    </Link>
                    :
                    <Link to='/'>
                        <img style={{marginTop: "32px", marginBottom: "32px", marginLeft: "18px"}} src={Logo} alt="로고" />
                    </Link>
                }
                {
                    isLogin ?
                    <>
                    <ul>
                        <li>
                            <Link className="side-nav-item" to="/Home">
                                <FontAwesomeIcon icon={faHouse} />
                                <span>HOME</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="side-nav-item" to="/Setting">
                                <FontAwesomeIcon icon={faGear} />
                                <span>설정</span>
                            </Link>
                        </li>
                        <li>
                            <Link className="side-nav-item" to="/Customer">
                                <FontAwesomeIcon icon={faWrench} />
                                <span>고객지원</span>
                            </Link>
                        </li>
                    </ul>
                    <ul className="footer" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li style={{ marginTop: '150px', marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>고객센터</p>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faPhone} />
                                <span>070-4352-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faFax} />
                                <span>070-4325-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <a href="mailto:support@semiquz.co.kr" style={{ color: '#ccc', textDecoration: 'none' }}>
                                    support@semiquz.co.kr
                                </a>
                            </div>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Address</p>
                            <p>
                                경기도 평택시 고덕중앙로 200-4 (고덕동, 우성고덕타워)
                                <br />
                                (우 18014)
                            </p>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>English Address</p>
                            <p>
                                200-4, Godeokjungang-ro,
                                <br />
                                Pyeongtaek-si, Gyeonggi-do,
                                <br />
                                Republic of Korea, zip code: 18014
                            </p>
                        </li>
                        <li className="copyright" style={{ marginTop: '20px' }}>
                            Copyright ⓒ 2025 SEMIQUZ, All Right Reserved.
                        </li>
                    </ul>
                    </>
                    :
                    <ul className="footer" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                        <li style={{ marginTop: '150px', marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>고객센터</p>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faPhone} />
                                <span>070-4352-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px', marginBottom: '5px' }}>
                                <FontAwesomeIcon icon={faFax} />
                                <span>070-4325-0624</span>
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <FontAwesomeIcon icon={faEnvelope} />
                                <a href="mailto:support@semiquz.co.kr" style={{ color: '#ccc', textDecoration: 'none' }}>
                                    support@semiquz.co.kr
                                </a>
                            </div>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>Address</p>
                            <p>
                                경기도 평택시 고덕중앙로 200-4 (고덕동, 우성고덕타워)
                                <br />
                                (우 18014)
                            </p>
                        </li>
                        <li style={{ marginBottom: '20px' }}>
                            <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>English Address</p>
                            <p>
                                200-4, Godeokjungang-ro,
                                <br />
                                Pyeongtaek-si, Gyeonggi-do,
                                <br />
                                Republic of Korea, zip code: 18014
                            </p>
                        </li>
                        <li className="copyright" style={{ marginTop: '20px' }}>
                            Copyright ⓒ 2025 SEMIQUZ, All Right Reserved.
                        </li>
                    </ul>
                }
                </div>
            }
            </div>
        </div>
    )
}

export default SideNav;
